// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { observable, action } from "mobx";
import { SictmApi } from "../api/sictm.api";

export default class SictmStore {
  @observable lines: any = [];
  @observable nextHours: any = [];

  @action getLines = async (companyId: number) => {
    this.lines = await SictmApi.getLines(companyId);
  };

  @action getNextStops = async (id: number) => {
    this.nextHours = await SictmApi.getNextStops(id);
  };
}
